<template>
    <div class="d-flex min-vh-100 justify-content-center flex-column ds-background-primary">
        <div class="text-center">
            <Login/>
        </div>
    </div>
</template>
<script>
    import Login from '@/components/auth/Login';

    export default {
        name: 'auth',
        components: {Login},
    }
</script>